import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {formValueSelector, reduxForm} from 'redux-form';
import useLabels from 'infrastructure/js/hooks/useLabels';
import Dialog from 'infrastructure/js/components/Dialog/dialog';
import InputSection from 'infrastructure/js/components/Dialog/InputSection/inputSection';
import TextField from 'infrastructure/js/components/controls/TextField/textField';
import {EntityPropertyTypes} from '../../../enums/entityPropertyTypes';
import {FetchEntitiesFilters} from '../../../enums/fetchEntitiesFilters';
import {useEffect, useState} from 'react';
import {getAssetStatusesOptions, round} from '../../../utils/assetHelper';
import {enumTypes, getEnumLabel, getEnumValue} from '../../../utils/enumHelper';
import UnitHelper, {unitTypes, UOM_DEFAULT_PRECISION} from 'infrastructure/js/utils/uomHelper';
import EntitiesMultiSelect from '../../Common/Controls/EntitiesMultiSelect/entitiesMultiSelect';
import List from 'infrastructure/js/components/List/list';
import Combobox from 'infrastructure/js/components/controls/Combobox/combobox';
import TextAreaField from 'infrastructure/js/components/controls/TextAreaField/textAreaField';
import AssetLengthListItem from '../../Common/Controls/AddRemoveList/AddRemoveListItem/AssetLengthListItem/assetLengthListItem';
import NameValuePairs from '../../Common/NameValuePairs/nameValuePairs';
import MaterialHelper from '../../../utils/materialHelper';
import Button from 'infrastructure/js/components/controls/Button/button';
import Normalize from 'infrastructure/js/components/controls/controlsNormalizations';
import AssetGenerateListItem from '../../Common/Controls/AddRemoveList/AddRemoveListItem/AssetGenerateListItem/assetGenerateListItem';
import * as dialogHelper from 'infrastructure/js/components/Dialog/dialogHelper';

import './slitRollsToCassettesDialog.scss';


const WO_ENTITIES_TYPES = [getEnumValue(enumTypes.OBJECT_TYPE)('WO')];

const WO_FETCH_CONFIG = {
  entityType: EntityPropertyTypes.WO_BUSINESS_ID,
  filter: [FetchEntitiesFilters.ACTIVE],
};

const getStatuses = () => {
  return getAssetStatusesOptions();
}

const getInitialRolls = (items = []) => {
  return items.map((item) => {
    return {
      asset: {
        assetsType: {
          value: getEnumValue(enumTypes.OBJECT_TYPE)('ROLL'),
          label: getEnumLabel(enumTypes.OBJECT_TYPE)('ROLL'),
        },
        assetsValue: {
          value: item.id,
          label: item.businessId,
          data: item
        }
      },
      length: item.lengthLeft ? UnitHelper.serverValueToUserValue(unitTypes.LENGTH, item.lengthLeft) : 0,
    }
  });
}

const getComponentToRender = (props) => {
  if (!props?.data ) {
    return null;
  }
  let option = props.data;
  return <span className={option.isDisabled ? 'sub-rolls-status-title' : 'sub-rolls-status'}>{option.label}</span>
}

 const getLabelExtraComponent = (value) => {
  return (
    <span className="label-extra-component">{value}</span>
  )
}

const createSourceRolls = (items = []) => {
  return items.map(item => {
    return (
      {
        rollId: item?.asset?.assetsValue?.data?.id,
        lengthToConsume: UnitHelper.userValueToServerValue(unitTypes.LENGTH, +(item?.length) ?? 0)
      });
  });
}

const createCassettes = (items) => {
  return items.map(item => {
    return (
      {
        businessId: item?.asset,
        width: UnitHelper.userValueToServerValue(unitTypes.WIDTH, +(item?.quantity) ?? 0)
      });
  });
}


export function SlitRollsToCassettesDialog( props ) {

  const {
    actions,
    fetchEntitiesActions,
    sData,
    handleSubmit,
    change,
    touch,
    initialize,
    pristine = false,
    reloadParentComponent = null,
    rollsFieldsValues = [],
    cassettesFieldsValues = [],
    cutWidthFieldValue = 0,
    cassettesNumberFieldValue = 0,
    ...others} = props;

  const dialogLabels = useLabels('mat.dialog.');
  const labels = useLabels('mat.locationPage.view.slitting.slitRollsToCassettes.dialog.');
  const [rollWidth, setRollWidth] = useState(0);
  const [rollInfo, setRollInfo] = useState([]);
  const [totalCutLength, setTotalCutLength] = useState(0);
  const [remainingWidth, setRemainingWidth] = useState(0);
  const [autoGenerateEnabled, setAutoGenerateEnabled] = useState(false);
  const [printPdfLabels, setPrintPdfLabels] = useState(false);

  const footerCheckbox = {
    text: labels.get('footer.printPdfLabels'),
    action: (value) => {
      setPrintPdfLabels(value)
    }
  };

  const woFetchConfig = {
    ...WO_FETCH_CONFIG,
    action: fetchEntitiesActions.fetchEntities,
  };

  const items = sData?.get('preselectedAssets')?.toJS() ?? [];
  const [item] = items;


  const rollsFetchConfig = {
    entityType: EntityPropertyTypes.ROLL_BUSINESS_ID,
    filter: [FetchEntitiesFilters.ACTIVE],
    action: fetchEntitiesActions.fetchEntities,
    searchBy: {
      roll: [{
        objectName: 'widthInCentimeter',
        // values: [item?.width]
        values: [item?.widthInCentimeter]
      },
        {
          objectName: 'materialId',
          values: [item?.material?.id]
        },
      ]
    }
  };

  useEffect(() => {
    const items = sData?.get('preselectedAssets')?.toJS() ?? [];
    const [item] = items;

    // const width = UnitHelper.serverValueToUserValue(unitTypes.WIDTH, item?.width) ?? 0;
    const width = UnitHelper.serverValueToUserValue(unitTypes.WIDTH, item?.widthInCentimeter) ?? 0;
    const material = MaterialHelper.getMaterialFullLabel(item?.material?.materialName, item?.material?.businessId) ?? null;

    setRollWidth(width);
    setRemainingWidth(width);

    setRollInfo([
      {
        label: labels.get('material'),
        value: material,
      },
      {
        label: labels.get('width'),
        value: `${width} ${UnitHelper.getLabelForUnitType(unitTypes.WIDTH)}`,
      },
    ]);

    initialize({
      rollsList: getInitialRolls(items) ?? [{}],
      cassettesList: [{}],
      // cutWidth: width,
    });
  }, []);


  useEffect(() => {
    updateTotalLength();
  }, [rollsFieldsValues]);

  useEffect(() => {
    updateRemainingWidth()
  }, [cassettesFieldsValues, rollWidth]);

  useEffect(() => {
    validateAutoGenerate();
  }, [cutWidthFieldValue, rollWidth]);

  useEffect(() => {
    validateAutoGenerate()
  }, [cassettesNumberFieldValue, rollWidth]);

  const validateAutoGenerate = () => {
    const cutWidth = Number(cutWidthFieldValue);
    const cassettesNumber = Number(cassettesNumberFieldValue);

    const isValid =
      cutWidth > 0 &&
      cassettesNumber > 0 &&
      round(cutWidth * cassettesNumber, UOM_DEFAULT_PRECISION) <= rollWidth;

    setAutoGenerateEnabled(isValid);
  };


  const getDialogButtons = () => {
    return {
      left: [
        {
          id: 'cancel',
          text: dialogLabels.get('cancel'),
          action: actions.hide,
        },
      ],
      right: [
        {
          id: 'submit',
          text: labels.get('footer.performOperation'),
          bsStyle: 'primary',
          loading: sData.get('loading'),
          action: handleSubmit(onSubmit),
          disabled: pristine || sData.get('loading') ||
                    sData.get('hasError') ||
                    (sData.get('showIgnoreValidationCheckbox') &&
                      !sData.get('isIgnoreValidationWarnings')),
        },
      ],
    };
  }

  const onSubmit = (data) => {
    let submitData = {
      cassettesStatus: data?.cassettesStatus?.value,
      comment: data?.comment ?? '',
      workOrder: data?.workOrder?.assetsValue?.label ?? null,
      sourceRolls: createSourceRolls(data?.rollsList ?? []),
      cassettes: createCassettes(data.cassettesList ?? []),
      ignoreValidationWarnings:
        sData.get('showIgnoreValidationCheckbox') && data.footerValidationCheckbox
          ? data.footerValidationCheckbox
          : false,
    };

    actions.submit(submitData, null, reloadParentComponent, printPdfLabels);
  };

  const onHide = () => {
    actions.hide();
  };

  const getTotalLength = () => {
    let sum = rollsFieldsValues?.reduce((previous, current) => {
      let cutQuantity = current.length ?? 0;
      return previous + (+(cutQuantity) );
    }, 0) ?? 0;

    return round(sum, UOM_DEFAULT_PRECISION);
  }

  const updateTotalLength = () => {
    const length = getTotalLength();
    setTotalCutLength(length);
  }

  const getRemainingWidth = () => {
    let sum = cassettesFieldsValues?.reduce((previous, current) => {
      let cutQuantity = current.quantity ?? 0;
      return previous + (+(cutQuantity) );
    }, 0) ?? 0;

    return round(rollWidth - sum, UOM_DEFAULT_PRECISION);
  }

  const updateRemainingWidth = () => {
    const width = getRemainingWidth();
    setRemainingWidth(width);
  }

  const onGenerateClickCallback = (index) => {
    actions.generateCassetteId().then((response) => {
        change( `cassettesList[${index}].asset`, response.data);
      }
    );
  };

  const onAutoGenerateClick = () => {

    const data = {
      quantity: Number(cassettesNumberFieldValue),
      coreBusinessId: null,
      startingCounter: null,
      staticRandomCore: false
    }

    actions.autoGenerateCassettes(data).then((response) => {
      let value = [{}];
      if (response?.generatedIds?.length) {
        value = response?.generatedIds.map(item => {
          return {asset:  item, quantity: cutWidthFieldValue}});
      }
      change('cassettesList', value);
    });
  };

  const getRollsItemRenderer = (data) => {
    return (
      <AssetLengthListItem
        {...data}
        fetchConfig={rollsFetchConfig}
        change={change}
        touch={touch}
        assetType={getEnumValue(enumTypes.OBJECT_TYPE)('ROLL')}
      />
    )
  }

  const getMaxQuantityByIndex = (index) => {
    let allRows = cassettesFieldsValues;

    if (allRows && allRows.length > index) {
      let quantity = +(allRows[index]?.quantity) || 0;
      return quantity + getRemainingWidth();
    }
    return remainingWidth;
  };

  const getCassettesItemRenderer = (data) => {
    let maxQuantity = getMaxQuantityByIndex(data.index);

    return (
      <AssetGenerateListItem
        {...data}
        change={change}
        touch={touch}
        labels={labels}
        onGenerateClickCallback={onGenerateClickCallback}
        maxQuantity={maxQuantity}
      />
    )
  }


  const renderTotalCutLength = () => {
    return  (
      <div className="list-bottom">
        <span>{labels.get('totalCutLength', '', {totalCutLength})}</span>
        <span className="units">{`(${UnitHelper.getLabelForUnitType(unitTypes.LENGTH)})`}</span>
      </div>
    )
  }

  const renderRemaining = () => {
    return  (
      <div className="list-bottom">
        <span>{labels.get('remainingWidth', '', {remainingWidth})}</span>
        <span className="units">{`(${UnitHelper.getLabelForUnitType(unitTypes.WIDTH)})`}</span>
      </div>
    )
  };

  const getFooterValidationCheckBox = () => {
    return sData.get('showIgnoreValidationCheckbox')
      ? { label: dialogLabels.get('ignorewarnings'), onChange: onFooterValidationChange }
      : null;
  };

  const onFooterValidationChange = (value) => {
    actions.toggleIgnoreValidationWarningsCheckbox(value);
  };


  return (
    <Dialog
      id="slit-rolls-to-cassettes-dialog"
      className="slit-rolls-to-cassettes-dialog"
      titleText={labels.get('header.title')}
      footerCheckbox={footerCheckbox}
      show={sData.get('show')}
      onHide={onHide}
      sData={sData}
      footerButtons={getDialogButtons()}
      footerValidationCheckbox={getFooterValidationCheckBox()}
      footerInformationIcon={dialogHelper.getFooterInformationIcon(
        sData,
        dialogLabels
      )}
      onEnterKeyPress={handleSubmit(onSubmit)}
    >
      <InputSection label={labels.get('workOrder')} htmlFor="workOrder" className="work-order-section inline left-side no-margin">
        <EntitiesMultiSelect
          id="workOrder"
          name="workOrder"
          entitiesTypes={WO_ENTITIES_TYPES}
          fetchConfig={woFetchConfig}
          change={change}
          isMulti={false}
          showEntitiesTypes={false}
          autoFocus={true}
        />
      </InputSection>

      <InputSection className='inline right-side'/>

      <div className='rolls-details-section input-section inline left-side'>
        <NameValuePairs items={rollInfo}/>
      </div>

      <div className='input-section inline right-side no-margin'>
        <div className='auto-generate-section'>
          <InputSection label={labels.get('number')} htmlFor="cassetsNumber" className="no-margin">
            <TextField id='cassetsNumber' name='cassetsNumber'
                       normalize={Normalize.number(true, 1, 60)}
                       placeholder={`${1}-${60}`}
            />
          </InputSection>
          <InputSection label={labels.get('cutWidth')} htmlFor="cutWidth" className="no-margin"
                        labelExtraComponent={getLabelExtraComponent(`(${UnitHelper.getLabelForUnitType(unitTypes.WIDTH)})`)}
          >
            <TextField id='cutWidth' name='cutWidth'
                       normalize={Normalize.normalizeFloat(0, parseFloat(rollWidth))}
                       // placeholder={`${0}-${parseFloat(rollWidth)}`}
            />
          </InputSection>
          <Button id='autoGenerate' bsStyle="primary"
                  disabled={!autoGenerateEnabled}
                  onClick={onAutoGenerateClick}>
            {labels.get('autoGenerate')}

          </Button>
        </div>
      </div>


        <div className='assets-container'>

          <div className='assets-container-left'>
            <div className="list-title">
              <span>{labels.get('rolls') + '*'}</span>
              <div>
                <span>{labels.get('cutLength')}</span>
                <span className="units">{`(${UnitHelper.getLabelForUnitType(unitTypes.LENGTH)})*`}</span>
              </div>
            </div>

            <div className='rolls-list-container'>
              <List
                id='rollsList'
                name='rollsList'
                className='rolls-list'
                itemRenderer={getRollsItemRenderer}
                minFieldsCount={1}
                maxItemsToOverflow={6}
                addButtonLabel={labels.get('rollsList.button.add')}
              />
              {renderTotalCutLength()}
            </div>
          </div>

          <label className="add-to-asset-arrow">
            <i className="pl pl-move-arrow-right"></i>
          </label>

          <div className='assets-container-right'>
            <div className="list-title">
              <span>{labels.get('cassettes') + '*'}</span>
              <div>
                <span>{labels.get('cutWidth')}</span>
                <span className="units">{`(${UnitHelper.getLabelForUnitType(unitTypes.WIDTH)})*`}</span>
              </div>
            </div>

            <div className='cassettes-list-container'>
              <List
                id='cassettesList'
                name='cassettesList'
                className='cassettes-list'
                itemRenderer={getCassettesItemRenderer}
                minFieldsCount={1}
                maxItemsToOverflow={5}
                addButtonLabel={labels.get('cassettesList.button.add')}
              />
              {renderRemaining()}
            </div>

            <InputSection label={labels.get('cassettesStatus')} htmlFor="cassettesStatus" className="">
              <Combobox
                id="cassettesStatus"
                name="cassettesStatus"
                options={getStatuses()}
                optionRenderer={getComponentToRender}
              />
            </InputSection>
          </div>
        </div>


        <InputSection label={labels.get('comment')} htmlFor="comment" className="full-width">
          <TextAreaField id="comment-textField" name="comment" className="comment-textField"
                         placeholder={labels.get('comment.placeholder')}/>
        </InputSection>

    </Dialog>
);
}


SlitRollsToCassettesDialog = reduxForm({
  form: 'slitRollsToCassettesDialog',
  onChange: (values, dispatch, props, previousValues) => {
    dialogHelper.onFormChangeHandler(values, props, previousValues);
  },
})(SlitRollsToCassettesDialog);

const selector = formValueSelector('slitRollsToCassettesDialog');

export default SlitRollsToCassettesDialog = connect( state => {
  return {
    rollsFieldsValues: selector(state, 'rollsList'),
    cassettesFieldsValues: selector(state, 'cassettesList'),
    cutWidthFieldValue: selector(state, 'cutWidth'),
    cassettesNumberFieldValue: selector(state, 'cassetsNumber'),
  }
})( SlitRollsToCassettesDialog );

SlitRollsToCassettesDialog.propTypes = {
  actions: PropTypes.object.isRequired,
  fetchEntitiesActions: PropTypes.object.isRequired,
  sData: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func,
  change: PropTypes.func,
  touch: PropTypes.func,
  initialize: PropTypes.func,
  pristine: PropTypes.bool,
  reloadParentComponent: PropTypes.func,
};
